<template>
  <div class="versions-view">
    <b-table striped hover
      :fields=tableFields
      :items=versions
      :sort-by.sync=sortBy>
    </b-table>
  </div>
</template>

<script>
import versionService from '@/domain/services/generalPanel/versions';
import { formats } from '@/constants/localizer';
import dateTimeFilter from '@/filters/dateTimeFilter';

export default {
  computed: {
    appVersion() {
      return this.$store.getters.appVersion;
    },
    tableFields() {
      const fieldApplication = this.$t('fields.menuVersion.columnApplication');
      const fieldVersion = this.$t('fields.menuVersion.columnVersion');
      const fieldDateTime = this.$t('fields.menuVersion.columnDateTime');
      return [
        {
          key: 'aplicacao',
          label: fieldApplication,
        },
        {
          key: 'numeroVersao',
          label: fieldVersion,
        },
        {
          key: 'dataHoraUltimaExecucaoAplicacao',
          label: fieldDateTime,
          formatter: value => dateTimeFilter(
            value,
            { format: formats.DATETIME_SHORT_WITH_SECONDS },
          ),
        },
      ];
    },
  },
  data: () => ({
    formats,
    versions: null,
    sortBy: 'aplicacao',
  }),
  created() {
    this.getVersions();
  },
  methods: {
    getVersions() {
      versionService.getVersions()
        .then((versions) => {
          versions.push({
            aplicacao: 'Aplicação web',
            numeroVersao: this.appVersion,
          });
          this.versions = versions;
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.versions-view
  & ::v-deep
    & p:first-child
      padding-top: 2.8rem

    & h1
      padding-top: 2.3rem
      padding-bottom: 1.2rem
      font-size: 1.3rem

    & h2
      font-weight: bold
      padding-bottom: 0.6rem

    & h3
      font-weight: bold
      padding-bottom: 0.6rem
</style>
